import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-ivory">
      <div className="max-w-2xl mx-auto px-5 py-10 space-y-6">
        <div>
          <div className="label-overline">Legal</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight mt-2 text-ink-900">Terms &amp; Conditions</h1>
          <p className="text-ink-500 text-sm mt-2">
            Last updated: {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </div>

        <div className="rounded-2xl bg-amber-soft border border-amber-deep/30 p-4 text-sm text-ink-800">
          <strong>Placeholder version.</strong> These terms reflect how AMDS operates today.
          Trading name, jurisdiction and refund specifics will be finalised before formal
          launch.
        </div>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">1. About AMDS</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          AMDS (&quot;All Musicians Diary Service&quot;) is an online diary, availability and
          dep-finding service for musicians, conductors, orchestra managers and ensemble
          fixers, operated by <strong>[[YOUR BUSINESS NAME]]</strong>. By creating an
          account you agree to these Terms and to the{" "}
          <Link className="text-sage-600 underline" to="/privacy-policy">Privacy Policy</Link>.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">2. Beta status</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          AMDS is currently in <strong>public beta</strong>. Features may change, break, or
          be removed. During beta the platform is offered on an &quot;as is&quot; basis. You should
          not treat AMDS as your sole system of record for critical bookings — keep a
          backup.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">3. Your account</h2>
        <ul className="list-disc pl-6 space-y-1 text-ink-800 text-sm">
          <li>You must be over 16 to create an account.</li>
          <li>You are responsible for keeping your password confidential.</li>
          <li>You must supply an email you actively read — verification is required.</li>
          <li>Impersonation, fake accounts and abuse are grounds for immediate suspension.</li>
        </ul>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">4. Bookings and deps</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          AMDS facilitates communication between musicians and the people who book them.
          Any contractual relationship — fee, cancellation, expenses, dress code — is
          between the two parties directly. AMDS is not a party to bookings and does not
          collect fees on behalf of musicians unless expressly stated.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">5. Content</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          You retain ownership of what you enter into AMDS (diary events, profile bio,
          ensemble names, uploaded documents). You grant AMDS a limited licence to store,
          transmit and display your content solely to run the service.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">6. Paid tiers &amp; refunds</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          Paid subscriptions (where offered) auto-renew unless cancelled. You may cancel at
          any time from your Profile — cancellation takes effect at the end of the current
          billing period. Refunds are considered case-by-case; write to
          <strong> [[support@amdsdiary.org]]</strong>.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">7. Prohibited use</h2>
        <ul className="list-disc pl-6 space-y-1 text-ink-800 text-sm">
          <li>Scraping or automated bulk-fetching of musician profiles or availability data.</li>
          <li>Sending unsolicited marketing via the messaging system.</li>
          <li>Uploading illegal, defamatory or harassing content.</li>
          <li>Attempting to circumvent security, rate limits or authentication.</li>
        </ul>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">8. Liability</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          To the fullest extent permitted by law, AMDS is not liable for indirect,
          consequential or economic loss arising from use of the service. Nothing in these
          Terms limits liability for death, personal injury or fraud.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">9. Termination</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          You may delete your account at any time from Profile → Settings. AMDS may
          suspend or terminate accounts that breach these Terms.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-ink-900 mt-8">10. Governing law</h2>
        <p className="text-ink-800 text-sm leading-relaxed">
          These Terms are governed by the laws of <strong>[[England &amp; Wales]]</strong>.
          Disputes are subject to the exclusive jurisdiction of the English courts.
        </p>

        <p className="text-center text-ink-500 text-xs mt-10">
          <Link to="/" className="hover:text-sage-600">Back to AMDS</Link>
        </p>
      </div>
    </div>
  );
}
